import { render, staticRenderFns } from "./range.pug?vue&type=template&id=7a7368c0&lang=pug&"
import script from "./range.js?vue&type=script&lang=js&"
export * from "./range.js?vue&type=script&lang=js&"
import style0 from "./range.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a7368c0')) {
      api.createRecord('7a7368c0', component.options)
    } else {
      api.reload('7a7368c0', component.options)
    }
    module.hot.accept("./range.pug?vue&type=template&id=7a7368c0&lang=pug&", function () {
      api.rerender('7a7368c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/range/index.vue"
export default component.exports